export default __webpack_public_path__ + "static/media/NavbarSearch.9462a2a7.svg";